import React, { useState } from 'react';
import { Form, Button } from 'react-bootstrap';
import { bookOpenIcon } from '../../constants/icons';
import { useNavigate } from 'react-router-dom';

function ForgotPassword() {
    const [email, setEmail] = useState('');
    const [emailSent, setEmailSent] = useState(false);
    const navigate = useNavigate();

    const handleSubmit = (event) => {
        event.preventDefault();

        if (email) {
            setEmailSent(true);
        } else {
            alert("Please enter your email.");
        }
    };

    return (
        <div className="login-wrapper">
            <div className="login-container">
                <div className="login-logo-wrap">
                    <div className="login-logo">{bookOpenIcon}</div>
                    <h4>Examally</h4>
                </div>

                {emailSent ? (
                    <>
                        <h2 className="login-title">Forgot Password?</h2>
                        <Form className="login-form">
                            <p>We have sent you a password reset link to <strong>{email}</strong>. Please check your email.</p>
                            <Button className="login-btn" variant="primary" onClick={() => navigate('/login')}>
                                Back To Login
                            </Button>
                        </Form>
                    </>
                ) : (
                    <>
                        <h2 className="login-title">Forgot Password?</h2>
                        <Form className="login-form" onSubmit={handleSubmit}>
                            <p>Please enter your email address, we will send you an email about how to reset your password.</p>
                            <Form.Group controlId="emailAddress">
                                <Form.Label>Email address</Form.Label>
                                <Form.Control
                                    type="email"
                                    placeholder="Enter your email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                />
                            </Form.Group>
                            <Button className="login-btn" variant="primary" type="submit">
                                Continue
                            </Button>
                        </Form>
                    </>
                )}
            </div>
        </div>
    );
}

export default ForgotPassword;
